import { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { addAttachment, deleteTempAttachment } from "./AttachmentSlice";
import moment from "moment";
import { toAbsoluteUrl } from "../../_metronic/helpers";
import { t } from "i18next";
import { ShowToast } from "../../common/Toastr";
import { getValueFromResource } from "../../common/timeLiveFunction";
const errormessage: any = {
    fontSize: '14px', color: 'red', marginTop: '5px', whiteSpace: 'pre-line'
}

export const AttachmentUpload = (props: any) => {
    const { Id, onupdateTempAttachmentId, clearRef, AccountAttachmentTypeId } = props;
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [files, setFiles]: any = useState([]);
    const { employeeInformation } = useAppSelector((state) => state.attachment);
    const {employeeName: EmpName}=useAppSelector((state)=> state.globalState)
    const { employeeName, IsShowLockSubmittedRecords, IsShowLockApprovedRecords } = useAppSelector((state) => state.timesheet);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorImages, setErrorImages] = useState<any>([]);
    const { getRootProps, getInputProps } = useDropzone({
        onDrop: acceptedFiles => {
            const formData = new FormData();
            acceptedFiles.forEach((file: any, index: any) => {
                formData.append('files' + index, file);
            });
            let param: any = {};
            if (Id !== undefined && Id !== null && Id !== '' && Id !== '00000000-0000-0000-0000-000000000000' && Id !== 0) {
                param = { Id: Id, formData: formData, IsEdit: true, AccountAttachmentTypeId: AccountAttachmentTypeId } 
            }
            else {
                param = { Id: null, formData: formData, IsEdit: false, AccountAttachmentTypeId: AccountAttachmentTypeId }
                deleteTempAttachmentMethod();
            }
            dispatch(addAttachment(param))
                .then(response => {
                    if (response.payload.id === null && response.payload.Result === null) {
                        const stringArray = response.payload.message.split(',');
                        const errorMessageText = stringArray.map((item: any) => `${item} is already exist`).join('\n');
                        setErrorMessage(errorMessageText);
                    }
                    else {
                        setErrorMessage('');
                        onupdateTempAttachmentId(response.payload.id);
                        localStorage.setItem('localTempAttachmentId', response.payload.id);
                        ShowToast(response.payload.message, 'Success', "success", "toast-top-right");                        
                    }
                })
                .catch(error => {
                });

            setFiles(acceptedFiles.map((file: any) => Object.assign(file, {
                preview: URL.createObjectURL(file)
            })));
        },
        accept: {
            "image/*": [".png", ".gif", ".jpeg", ".jpg", ".pdf", ".xls", ".xlsx", ".docx"],
        },
        maxSize: 31457280
    });

    const handleClear = () => {
        setFiles([]);
        onupdateTempAttachmentId(null);
        setErrorImages([]);
    };

    const deleteTempAttachmentMethod = () => {
        let localTempAttachmentId = localStorage.getItem('localTempAttachmentId');
        if (localTempAttachmentId) {
            dispatch(deleteTempAttachment({ AccountAttachmentId: localTempAttachmentId, AttachmentName: "" }))
                .then(async response => {
                    if (response.payload.ResponseMessage === 'True' && response.payload.Id === localTempAttachmentId) {
                        localStorage.removeItem('localTempAttachmentId');
                    }
                })
                .catch(error => {// Handle error
                });
        }
    };

    useEffect(() => {
        deleteTempAttachmentMethod();
        setErrorMessage('');
        setErrorImages([]);
    }, []);

    useEffect(() => {
        if (clearRef) {
            clearRef.current = handleClear;
        }
    }, [clearRef, handleClear]);

    const handleDelete = async (name: string) => {
        let localTempAttachmentId = localStorage.getItem('localTempAttachmentId')
        dispatch(deleteTempAttachment({ AccountAttachmentId: localTempAttachmentId, AttachmentName: name }))
            .then(async response => {
                if (response.payload.ResponseMessage === 'True' && response.payload.Id === localTempAttachmentId) {
                    localStorage.removeItem('localTempAttachmentId');
                }
                setLoading(true);
                const data = files;
                const filteredFiles = data.filter((file: any) => file.name !== name)
                await setFiles(filteredFiles.map((file: any) => Object.assign(file, {
                    preview: URL.createObjectURL(file)
                })));
                setLoading(false);
            })
            .catch(error => {
            });
    }

    function removeFileExtension(fileName: string) {
        const lastDotIndex = fileName.lastIndexOf('.');
        if (lastDotIndex === -1) {
            return fileName; // No extension found
        }
        return fileName.substring(0, lastDotIndex);
    }
    const formats = ['MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD', 'MM-DD-YYYY']; // Add more formats as needed
    const CurrentCultureDateFormatInUpperCase = 'DD/MM/YYYY';
    const noOfDaysAgo = (CreatedOn: any) => {
        // var createdDate = parseDate(moment(CreatedOn).format(CurrentCultureDateFormatInUpperCase)); //moment(CreatedOn).format("MM-DD-YYYY");
        // var currentDate = moment().format("MM-DD-YYYY");
        // var a = moment(createdDate, "MM-DD-YYYY");
        // var b = moment(currentDate, "MM-DD-YYYY");
        // return b.diff(a, 'days');
         const createdDate = moment(CreatedOn);
        const currentDate = moment();
        return currentDate.diff(createdDate, 'days');
    }
    function parseDate(dateString: string) {
        for (let format of formats) {
            const parsedDate = moment(dateString, format, true); // Use strict parsing mode
            if (parsedDate.isValid()) {
                return parsedDate;
            }
        }
        return 'Invalid date'; // If none of the formats matched
    }
    const handleImageError = (index: number) => {
        setErrorImages((prevErrorImages: any) => [...prevErrorImages, index]);
    };

    return (
        <>
            <div style={{ marginTop: 10 }}>
                <div {...getRootProps({ className: 'dropzone mb-2' })}
                    style={(
                        employeeInformation?.length > 0 && (
                            (AccountAttachmentTypeId === 3 && IsShowLockApprovedRecords && employeeInformation[0]?.ApprovalStatus === "Approved") ||
                            (AccountAttachmentTypeId === 1 && (
                                (IsShowLockSubmittedRecords && employeeInformation[0]?.Submitted) ||
                                (IsShowLockApprovedRecords && employeeInformation[0]?.Approved)
                            ))
                        )
                    ) ? { opacity: 0.5, pointerEvents: 'none' } : {}}
                >
                    <input {...getInputProps()} />
                    <p>
                        {/* {t("Drag 'n' drop some files here, or click to select files")} */}
                        {getValueFromResource("Drag 'n' drop some files here, or click to select files", dispatch, t)}

                    </p>
                    <p>
                        {/* {t('Max File Size is 30MB')} */}
                        {getValueFromResource('Max File Size is 30MB', dispatch, t)}

                    </p>
                </div>
                {errorMessage && <span style={errormessage} >{errorMessage}</span>}
                {Id !== 0 && Id !== undefined && Id !== null && Id !== '' && Id !== '00000000-0000-0000-0000-000000000000' ? (
                    <></>
                ) : (
                    <>
                        <table className="gvtabletodt table  order-column"  >
                            <thead>
                            </thead>
                            <tbody style={{ cursor: 'pointer' }}>                                
                                {                                    
                                    files?.length <= 0 ? (
                                        <div className=''><p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                        </div>
                                    ) : (
                                        files?.map((data: any, index: number) => {
                                            return (
                                                <>                                                
                                                    <tr key={data.AccountAttachmentId}>
                                                        <td style={{ width: "5%", paddingRight: 0, paddingLeft: 0 }} >
                                                        <a href={data.NewConvertAttachmentLocal} download>
                                                                <img
                                                                    src={errorImages.includes(index) ? toAbsoluteUrl('./media/images/defaultImageFile1.png') : data.preview}
                                                                    onError={() => handleImageError(index)}
                                                                    style={{ width: '40px', height: '40px' }}
                                                                    alt={`User Image ${index + 1}`}
                                                                    onLoad={() => { URL.revokeObjectURL(data.preview) }}
                                                                />
                                                            </a>
                                                        </td>
                                                        <td>
                                                            <div className='d-flex flex-column '>
                                                                <b>{removeFileExtension(data.name)}</b>
                                                                <p>by {employeeName != '' ? employeeName : EmpName} {noOfDaysAgo(new Date())}  days ago - {(data.size / 1000).toFixed(0)} KB </p>
                                                                
                                                                </div>
                                                        </td>
                                                        <td style={{ marginLeft: 'auto', width: '20%' }}>
                                                            <div className='d-flex align-items-center' style={{ borderRadius: '10px' }}>
                                                                <div className='btn btn-sm btn-icon btn-active-light-primary me-1 '
                                                                    onClick={() => handleDelete(data.name)}
                                                                >
                                                                    <i className='bi bi-trash fs-3'></i>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </>
                                            )
                                        }))
                                }
                            </tbody>
                        </table>
                    </>
                )}
            </div>
        </>
    );
}